import { mutatorAction } from "satcheljs";
import UserTeamSettingsStore from "../store";

/**
 * Sets error state when UserTeamSettings load fails for a team.
 *
 * USAGE:
 * - Called from bootstrap.ts after getUserTeamSettings() completes (success or error)
 * - Distinguishes between expected 404 "UserSettingsNotFound" (normal) vs actual errors (network, 500, etc.)
 *
 * ERROR STATE HANDLING:
 * - hasError = false: Normal state (loaded successfully or expected 404)
 * - hasError = true: Actual error occurred
 *   - Global banner: "We're unable to load your team specific settings" (all users)
 *   - Icon tooltip: "We're unable to load your mute schedule group preference" (users with editEnabled)
 *   - Menu item: Hidden (keeps menu clean)
 *
 * @param teamId - Team identifier
 * @param hasError - True if actual error occurred, false if loaded successfully or expected 404
 */
const setLoadError = mutatorAction(
    "SET_LOAD_ERROR",
    (teamId: string, hasError: boolean) => {
        const store = UserTeamSettingsStore();
        store.loadErrorByTeam.set(teamId, hasError);
    }
);

export default setLoadError;
